import i18n from '../i18n';
import { useNotificationStore } from '../store/notificationStore';
import { useExtensionStore } from './store';

const KIND = 'api-client-off';

/**
 * "The API Client is turned off" with a "Turn on" action — shown when
 * something asks for the API Client while its switch is off (a shortcut, a
 * chat reference, a shared request, the assistant). `reopen` runs after the
 * switch is back on, so the thing that was asked for still happens. One notice
 * at a time: a second attempt while it is up adds nothing.
 */
export function notifyApiClientOff({ reopen } = {}) {
  const store = useNotificationStore.getState();
  if ((store.notifications || []).some((n) => n.kind === KIND)) return null;
  return store.addNotification({
    kind: KIND,
    type: 'info',
    title: i18n.t('apiClientOff.title', 'API Client is turned off'),
    message: i18n.t('apiClientOff.message', 'Turn it on to open requests, collections and history. Nothing was deleted.'),
    action: {
      label: i18n.t('apiClientOff.turnOn', 'Turn on'),
      onClick: () => {
        useExtensionStore.getState().setApiClientEnabled(true);
        if (typeof reopen === 'function') reopen();
      },
    },
  });
}
